import React from 'react';
import { 
  IconCloudOff, 
  IconFileOff, 
  IconIdBadgeOff, 
  IconPaletteOff, 
  IconCreditCardOff,
  IconUsers,
  IconWorld,
  IconShield,
  IconKey,
  IconMail,
  IconUpload
} from '@tabler/icons-react';

export const EmptyStateIcons = {
  // General purpose
  general: IconCloudOff,
  files: IconFileOff,
  upload: IconUpload,
  
  // User/Identity related
  users: IconUsers,
  identity: IconIdBadgeOff,
  sso: IconShield,
  
  // Branding/Appearance
  branding: IconPaletteOff,
  appearance: IconPaletteOff,
  
  // Billing/Payment
  billing: IconCreditCardOff,
  
  // Domains/Infrastructure
  domains: IconWorld,
  subdomains: IconWorld,
  
  // Security/Access
  security: IconShield,
  keys: IconKey,
  
  // Communication
  email: IconMail
} as const;

export type EmptyStateIconType = keyof typeof EmptyStateIcons;
